import { useEffect, useState } from 'react'

/**
 * True only once `active` has been true for `delay` milliseconds without a
 * break, and false again the moment it stops.
 *
 * It is how a pending notice stays quiet about work that finishes quickly. A
 * fetch that resolves inside the delay never turns this true, so nothing is
 * mounted and nothing flashes — and that holds for a reader who has asked for
 * reduced motion, which a CSS animation delay does not: there the animation is
 * off and the notice would appear at once, on every pan.
 */
export default function useLate(active: boolean, delay: number): boolean {
  const [late, setLate] = useState(false)

  useEffect(() => {
    if (!active) {
      setLate(false)
      return
    }

    const timer = setTimeout(() => setLate(true), delay)

    return () => clearTimeout(timer)
  }, [active, delay])

  return active && late
}
